export const isInvalidElement = (type: string): boolean => {
  const superDom = ['HEAD', 'HTML'];
  const tagsWithNoChild = ['BR', 'HR'];
  const INVALID_ELEMENTS = ['IMG', 'SVG', 'TEXTAREA', 'INPUT', ...tagsWithNoChild, ...superDom];

  return INVALID_ELEMENTS.includes(type);
};
